import { render, staticRenderFns } from "./VideoProjectItemVideos.vue?vue&type=template&id=e6857dac&scoped=true&"
import script from "./VideoProjectItemVideos.vue?vue&type=script&lang=js&"
export * from "./VideoProjectItemVideos.vue?vue&type=script&lang=js&"
import style0 from "./VideoProjectItemVideos.vue?vue&type=style&index=0&id=e6857dac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6857dac",
  null
  
)

export default component.exports